import { apiClient } from "@/api/modules/base.ts";
import { Route } from "./routes.ts";
import type {
    ProductSearchFilterConfigurationResponse,
    ProductSearchRequest,
} from "./types.ts";
import { type AxiosPromise } from "axios";
import type {
    ProductSearchResponse
} from "./searchResultTypes.ts";

export const search = (payload: ProductSearchRequest): AxiosPromise<ProductSearchResponse> =>
    apiClient.post(Route.ProductSearch, payload);

export const configuration = (businessUnitId?: number): AxiosPromise<ProductSearchFilterConfigurationResponse> =>
    apiClient.get(Route.FilterConfiguration, { params: { businessUnitId } });